var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Toast',{attrs:{"icon":_vm.stateContent.icon,"loading":_vm.stateContent.loading},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.stateContent.title)+" ")]},proxy:true}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stateContent.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }